import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import ToastContainer from './components/ToastContainer';

// Pages (to be created)
import LoginPage from './pages/auth/LoginPage';
// import RegisterPage from './pages/auth/RegisterPage'; // Registration disabled
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import SetupPasswordPage from './pages/auth/SetupPasswordPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import RoadmapPage from './pages/roadmap/RoadmapPage';
import ItemDetailPage from './pages/roadmap/ItemDetailPage';
import ChangelogPage from './pages/changelog/ChangelogPage';
import SettingsPage from './pages/settings/SettingsPage';
import ActivityPage from './pages/activity/ActivityPage';
import OAuthCallbackPage from './pages/auth/OAuthCallbackPage';

function App() {
  const { isAuthenticated } = useAuthStore();

  return (
  <>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        {/* Registration disabled - users can only join via invitation */}
        {/* <Route path="/register" element={<RegisterPage />} /> */}
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/setup-password" element={<SetupPasswordPage />} />
        <Route path="/oauth/callback" element={<OAuthCallbackPage />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={isAuthenticated ? <DashboardPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/roadmap/:workspaceId"
          element={isAuthenticated ? <RoadmapPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/roadmap/:workspaceId/item/:itemId"
          element={isAuthenticated ? <ItemDetailPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/changelog/:workspaceId"
          element={isAuthenticated ? <ChangelogPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/settings/:workspaceId"
          element={isAuthenticated ? <SettingsPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/activity/:workspaceId"
          element={isAuthenticated ? <ActivityPage /> : <Navigate to="/login" />}
        />

        {/* Default redirect */}
        <Route
          path="/"
          element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />}
        />
      </Routes>
    </BrowserRouter>
    <ToastContainer />
  </>
  );
}

export default App;
